export enum AlchemerFeedbackWidget {
  OPEN = "BETA-PROGRAM:OPEN_FEEDBACK_WIDGET",
  SUBMIT = "BETA-PROGRAM:SUBMIT_FEEDBACK_WIDGET"
}
